import axios, { AxiosResponse, AxiosError } from 'axios'
import { useMetaStore } from '@/store/meta'
import { getAuthToken } from '@/services/auth-token'
import { reportServerError } from '@/services/server-error-reporter'

export type apiClientResponseType = AxiosResponse
export type apiClientErrorType = AxiosError

export function useApiClient(propertyId?: string) {
  const token = getAuthToken()

  const headers: { [index: string]: string } = {
    Accept: `application/json`,
    Authorization: `Bearer ${token}`,
    'Content-Type': `application/json`
  }

  const apiClient = axios.create({
    baseURL: import.meta.env.VITE_API_BASE_URL,
    headers: headers
  })

  apiClient.interceptors.request.use(function (config) {
    if (typeof propertyId !== 'undefined') {
      config.headers['Current-Property'] = propertyId
    }
    return config
  })

  apiClient.interceptors.response.use(
    function (response) {
      const metaStore = useMetaStore()
      metaStore.setLastUpdatedAt()
      return response
    },
    function (error) {
      if (axios.isAxiosError(error)) {
        reportServerError(error)
      }
      return Promise.reject(error)
    }
  )

  return apiClient
}
